import AiImageApp from './ai-image';

export default AiImageApp;
